import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { ThemeMode, ThemeStyle } from '../theme'

interface UiState {
  language: 'ar' | 'en'
  collapsed: boolean
  themeMode: ThemeMode
  /** «المظهر»: الكلاسيكي أو «ستوديو» — مستقلّ عن الفاتح/الداكن */
  themeStyle: ThemeStyle
  /** تصميم لوحة التحكم: حسب الثيم، أو «الفاخر» بهوية أفق — مستقلّ عن الثيم */
  dashboardStyle: DashboardStyle
}

export type DashboardStyle = 'theme' | 'prestige'

const initial: UiState = {
  language: (localStorage.getItem('ufuqerp_lang') as 'ar' | 'en') || 'ar',
  collapsed: false,
  themeMode: (localStorage.getItem('ufuqerp_theme') as ThemeMode) || 'light',
  themeStyle: localStorage.getItem('ufuqerp_style') === 'studio' ? 'studio' : 'classic',
  dashboardStyle: localStorage.getItem('ufuqerp_dashboard') === 'prestige' ? 'prestige' : 'theme',
}

const slice = createSlice({
  name: 'ui',
  initialState: initial,
  reducers: {
    setLanguage(state, a: PayloadAction<'ar' | 'en'>) {
      state.language = a.payload
      localStorage.setItem('ufuqerp_lang', a.payload)
    },
    setSidebarCollapsed(state, a: PayloadAction<boolean>) {
      state.collapsed = a.payload
    },
    toggleSidebar(state) {
      state.collapsed = !state.collapsed
    },
    setThemeMode(state, a: PayloadAction<ThemeMode>) {
      state.themeMode = a.payload
      localStorage.setItem('ufuqerp_theme', a.payload)
    },
    setThemeStyle(state, a: PayloadAction<ThemeStyle>) {
      state.themeStyle = a.payload
      localStorage.setItem('ufuqerp_style', a.payload)
    },
    setDashboardStyle(state, a: PayloadAction<DashboardStyle>) {
      state.dashboardStyle = a.payload
      try {
        localStorage.setItem('ufuqerp_dashboard', a.payload)
      } catch {
        /* تخزين محجوب — للجلسة فقط */
      }
    },
    toggleThemeMode(state) {
      state.themeMode = state.themeMode === 'light' ? 'dark' : 'light'
      localStorage.setItem('ufuqerp_theme', state.themeMode)
    },
  },
})

export const {
  setLanguage,
  setSidebarCollapsed,
  toggleSidebar,
  setThemeMode,
  setThemeStyle,
  setDashboardStyle,
  toggleThemeMode,
} = slice.actions
export default slice.reducer
